import { useParams } from 'react-router-dom'

import { useWidgetPageGetApi } from '@/common/api/modules/widgetPage'
import { useSiteId } from '@/common/app/site'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import WidgetPageEditPage from '@/components/container/page/site/recommend/widgetPage/WidgetPageEditPage'

const WidgetPageUpdatePage = () => {
  const siteId = useSiteId()
  const { widgetPageId } = useParams()

  const { data, error, mutate } = useWidgetPageGetApi({
    siteId,
    widgetPageId: Number(widgetPageId)
  })

  return (
    <DetailPageLoader error={error} data={data} small>
      <WidgetPageEditPage widgetPage={data} onRefetch={() => mutate()} />
    </DetailPageLoader>
  )
}

export default WidgetPageUpdatePage
